import React from 'react';
import { RCSwitch } from '@reverbdotcom/cadence/components';
import I18n from 'i18n-js';
import { withRouter, WithRouterProps } from 'react-router';
import { B_STOCK, NEW_GROUP, USED_GROUP } from '@reverbdotcom/commons/src/condition_helpers';
import { ShopBuyerCouponsFragment } from '../rql';

interface ExternalProps {
  coupon: ShopBuyerCouponsFragment.BuyerCoupons;
}

type IProps = ExternalProps & WithRouterProps;

const excludedBrandsParam = 'excludeBrandsSlugs';
const excludedCategoriesParam = 'excludeCategoryUuids';
const conditionParam = 'condition';
const showOnlyCouponParam = 'showOnlyCouponEligible';

export function CouponListingsToggle({ coupon, location, router }: IProps) {
  function toggleCouponListings(event) {
    const search = new URLSearchParams(location.search);

    if (event.target.checked) {
      coupon.excludedBrands.forEach(({ slug }) => search.set(`${excludedBrandsParam}[]`, slug));
      coupon.excludedProductTypes.forEach(({ uuid }) => search.set(`${excludedCategoriesParam}[]`, uuid));
      if (coupon.applyToNewConditions) search.set(`${conditionParam}[]`, NEW_GROUP);
      if (coupon.applyToBStockConditions) search.set(`${conditionParam}[]`, B_STOCK);
      if (coupon.applyToUsedConditions) search.set(`${conditionParam}[]`, USED_GROUP);
      search.set(showOnlyCouponParam, 'true');
    } else {
      search.delete(excludedBrandsParam);
      search.delete(`${excludedBrandsParam}[]`);
      search.delete(excludedCategoriesParam);
      search.delete(`${excludedCategoriesParam}[]`);
      search.delete(conditionParam);
      search.delete(`${conditionParam}[]`);
      search.delete(showOnlyCouponParam);
    }

    router.push({ pathname: location.pathname, search: `?${decodeURI(search.toString())}` });
  }

  const showOnlyCouponEligible = new URLSearchParams(location.search).has(showOnlyCouponParam);

  return (
    <RCSwitch checked={showOnlyCouponEligible} label={I18n.t('discovery.shopCoupons.onlyEligibleItems')} onChange={toggleCouponListings}/>
  );
}

export default withRouter(CouponListingsToggle);
